import { lazy } from 'react';

const MapView = lazy(() => import('./MapView'));
export default MapView;
